import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "town-zoning-plan-map" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2 small text-secondary" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-warning py-2 small mb-2"
}
const _hoisted_5 = {
  key: 1,
  class: "small text-secondary mb-2"
}
const _hoisted_6 = {
  key: 2,
  class: "alert alert-danger py-2 small mb-2"
}
const _hoisted_7 = {
  key: 3,
  class: "small mb-2"
}
const _hoisted_8 = { class: "text-secondary" }
const _hoisted_9 = { class: "row g-3" }
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "town-zoning-plan-map__map position-relative" }
const _hoisted_12 = {
  key: 0,
  class: "town-zoning-plan-map__prompt"
}
const _hoisted_13 = {
  key: 1,
  class: "town-zoning-plan-map__spinner"
}
const _hoisted_14 = { class: "d-flex flex-wrap align-items-center column-gap-3 row-gap-1 mt-2 small" }
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = ["for", "title"]
const _hoisted_17 = { class: "d-flex align-items-center gap-2 ms-lg-auto" }
const _hoisted_18 = { class: "col-lg-4" }
const _hoisted_19 = {
  key: 0,
  class: "btn-group btn-group-sm w-100 mb-2",
  role: "group",
  "aria-label": "Zobrazené plochy"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "small text-secondary mb-2"
}
const _hoisted_22 = {
  key: 2,
  class: "small text-secondary mb-2"
}
const _hoisted_23 = { class: "list-group town-zoning-plan-map__legend mb-2" }
const _hoisted_24 = ["title", "onMouseenter", "onClick"]
const _hoisted_25 = { class: "flex-grow-1 text-truncate" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-nowrap text-secondary" }
const _hoisted_28 = {
  key: 0,
  class: "list-group-item small text-secondary"
}
const _hoisted_29 = {
  key: 3,
  class: "d-flex align-items-center gap-2 small text-secondary px-2 mb-2"
}
const _hoisted_30 = { class: "d-flex justify-content-between small" }
const _hoisted_31 = {
  key: 4,
  class: "mt-3"
}
const _hoisted_32 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_33 = {
  key: 0,
  class: "small text-secondary"
}
const _hoisted_34 = {
  key: 1,
  class: "small text-secondary"
}
const _hoisted_35 = { class: "d-flex flex-wrap justify-content-between align-items-center column-gap-3 small mb-1" }
const _hoisted_36 = { class: "text-secondary" }
const _hoisted_37 = { class: "form-check form-switch mb-0" }
const _hoisted_38 = {
  key: 0,
  class: "small text-secondary"
}
const _hoisted_39 = { class: "list-group town-zoning-plan-map__proposed-areas" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "flex-grow-1 text-truncate" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "text-nowrap text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LControlZoom = _resolveComponent("LControlZoom")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        (_ctx.currency.state)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.currency.state), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currency.state && _ctx.map.geometrySource)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" · ")
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.map.geometrySource)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode("Zdroj: " + _toDisplayString(_ctx.sourceLabel(_ctx.map.geometrySource)), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_ctx.distinguishesPlanState)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Návrhové plochy jsou ohraničené přerušovanou čarou."))
        : _createCommentVNode("", true)
    ]),
    (_ctx.currency.warning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.currency.warning) + " Závazné je znění v dokumentech níže. ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.currency.info)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.currency.info) + " Závazné je znění v dokumentech níže. ", 1))
      : _createCommentVNode("", true),
    (_ctx.map.partialVectorization)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("span", { class: "fas fa-lock me-1" }, null, -1),
          _createTextVNode(" Vektorizace výkresu je jen „partial“ — uživatelé tuto mapu nevidí (zobrazeno jen pro admina). ", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.proposalSummary !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("strong", null, "Návrh plánu: " + _toDisplayString(_ctx.formatHectares(_ctx.proposedHectares)) + " ha", 1),
          _createElementVNode("span", _hoisted_8, " — " + _toDisplayString(_ctx.proposalSummary), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_LMap, {
            center: _ctx.initialCenter,
            zoom: 13,
            options: {zoomSnap: 0.25, zoomControl: false, maxZoom: 21},
            class: "h-100",
            onReady: _ctx.onMapReady
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LControlLayers, { position: "topright" }),
              _createVNode(_component_MapyCzBasicLayer),
              _createVNode(_component_MapyCzOrthoPhotoLayer, { visible: false }),
              _createVNode(_component_LControlZoom, { position: "topleft" })
            ]),
            _: 1
          }, 8, ["center", "onReady"]),
          (_ctx.zoomTooSmall)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Pro zobrazení ploch přibližte mapu "))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("div", {
                  class: "spinner-border spinner-border-sm",
                  role: "status"
                }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.returnableViews > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-light btn-sm shadow-sm town-zoning-plan-map__back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToPreviousView && _ctx.returnToPreviousView(...args)))
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("span", { class: "fas fa-arrow-left me-1" }, null, -1),
                _createTextVNode(" Zpět na předchozí výřez ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-secondary" }, "Další vrstvy:", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overlayLayers, (overlay) => {
            return (_openBlock(), _createElementBlock("div", {
              key: overlay.key,
              class: "form-check form-check-inline me-0 mb-0"
            }, [
              _withDirectives(_createElementVNode("input", {
                id: `town-zoning-plan-${overlay.key}`,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleOverlays) = $event)),
                value: overlay.key,
                type: "checkbox",
                class: "form-check-input"
              }, null, 8, _hoisted_15), [
                [_vModelCheckbox, _ctx.visibleOverlays]
              ]),
              _createElementVNode("label", {
                for: `town-zoning-plan-${overlay.key}`,
                class: "form-check-label",
                title: overlay.title
              }, _toDisplayString(overlay.label), 9, _hoisted_16)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_17, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "town-zoning-plan-opacity",
              class: "text-secondary text-nowrap mb-0"
            }, "Průhlednost ploch", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "town-zoning-plan-opacity",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fillOpacity) = $event)),
              type: "range",
              class: "form-range town-zoning-plan-map__opacity",
              min: "0.1",
              max: "0.9",
              step: "0.05"
            }, null, 512), [
              [
                _vModelText,
                _ctx.fillOpacity,
                void 0,
                { number: true }
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_ctx.distinguishesPlanState)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modeOptions, (option) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: option.mode,
                  type: "button",
                  class: _normalizeClass(["btn", _ctx.mode === option.mode ? 'btn-secondary' : 'btn-outline-secondary']),
                  onClick: ($event: any) => (_ctx.mode = option.mode)
                }, _toDisplayString(option.label), 11, _hoisted_20))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.distinguishesPlanState)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Zdroj dat nerozlišuje stávající stav a návrh. Které plochy jsou rozvojové, uvádí znění v dokumentech níže. "))
          : (_ctx.unknownStateHectares > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, " U " + _toDisplayString(_ctx.formatHectares(_ctx.unknownStateHectares)) + " ha ploch zdroj neuvádí, zda jde o stav, nebo návrh; v režimech Stav a Návrh nejsou vidět. ", 1))
            : _createCommentVNode("", true),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "d-flex justify-content-between small text-secondary px-2 mb-1" }, [
          _createElementVNode("span", null, "Legenda obce"),
          _createElementVNode("span", { title: "Podíl z ploch, které územní plán v mapě pokrývá" }, "ha · podíl z ploch plánu")
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendRows, (row) => {
            return (_openBlock(), _createElementBlock("button", {
              key: row.key,
              type: "button",
              class: _normalizeClass(["list-group-item list-group-item-action d-flex align-items-center gap-2 py-1 px-2 small", {'town-zoning-plan-map__legend-row--selected': _ctx.selectedKeys.includes(row.key)}]),
              title: row.title,
              onMouseenter: ($event: any) => (_ctx.hoveredKey = row.key),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hoveredKey = null)),
              onClick: ($event: any) => (_ctx.toggleSelected(row.key))
            }, [
              _createElementVNode("span", {
                class: "town-zoning-plan-map__swatch",
                style: _normalizeStyle({background: row.color})
              }, null, 4),
              _createElementVNode("span", _hoisted_25, [
                (row.code)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_26, _toDisplayString(row.code), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(row.name), 1)
              ]),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatHectares(row.hectares)) + " · " + _toDisplayString(_ctx.formatShare(row.hectares)), 1)
            ], 42, _hoisted_24))
          }), 128)),
          (_ctx.legendRows.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, " V tomto zobrazení nejsou žádné plochy. "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.map.annulledHectares > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
              _createElementVNode("span", {
                class: "town-zoning-plan-map__swatch town-zoning-plan-map__swatch--annulled",
                style: _normalizeStyle({borderColor: _ctx.annulledColor})
              }, null, 4),
              _createElementVNode("span", null, _toDisplayString(_ctx.annulledLegendLabel) + ": " + _toDisplayString(_ctx.formatHectares(_ctx.map.annulledHectares)) + " ha. " + _toDisplayString(_ctx.annulledExplanation), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-secondary" }, "Kliknutím na položku ji zvýrazníte v mapě.", -1)),
          (_ctx.selectedKeys.length > 0)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "text-nowrap ms-2",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.selectedKeys = []), ["prevent"]))
              }, "Zrušit výběr"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.proposalSummary !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-link btn-sm p-0 text-decoration-none",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleProposedAreas && _ctx.toggleProposedAreas(...args)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["town-zoning-plan-map__chevron me-1", {'town-zoning-plan-map__chevron--open': _ctx.proposedAreasOpen}])
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("span", { class: "fas fa-chevron-right" }, null, -1)
            ]))], 2),
            _cache[17] || (_cache[17] = _createTextVNode(" Seznam návrhových ploch ", -1))
          ]),
          (_ctx.proposedAreasOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (_ctx.proposedAreas === null && !_ctx.proposedAreasFailed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("span", {
                        class: "spinner-border spinner-border-sm me-1",
                        role: "status"
                      }, null, -1),
                      _createTextVNode(" Načítám návrhové plochy… ", -1)
                    ]))]))
                  : (_ctx.proposedAreasFailed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Návrhové plochy se nepodařilo načíst."))
                    : (_ctx.proposedAreas !== null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.filteredProposedAreas.length) + " z " + _toDisplayString(_ctx.proposedAreas.length) + " návrhových ploch" + _toDisplayString(_ctx.proposedAreasFilterLabel) + ", od největší; kliknutím plochu ukážete v mapě. ", 1),
                            _createElementVNode("div", _hoisted_37, [
                              _withDirectives(_createElementVNode("input", {
                                id: "town-zoning-plan-only-in-view",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.onlyInView) = $event)),
                                type: "checkbox",
                                class: "form-check-input"
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.onlyInView]
                              ]),
                              _cache[19] || (_cache[19] = _createElementVNode("label", {
                                for: "town-zoning-plan-only-in-view",
                                class: "form-check-label"
                              }, "Jen ve výřezu mapy", -1))
                            ])
                          ]),
                          (_ctx.filteredProposedAreas.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.onlyInView ? 'Ve výřezu mapy nejsou žádné návrhové plochy' : 'Žádné návrhové plochy') + _toDisplayString(_ctx.selectedKeys.length > 0 ? ' vybrané v legendě' : '') + ". ", 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownProposedAreas, (area, index) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: index,
                                type: "button",
                                class: _normalizeClass(["list-group-item list-group-item-action d-flex align-items-center gap-2 py-1 px-2 small", {'town-zoning-plan-map__legend-row--selected': area === _ctx.focusedArea}]),
                                onClick: ($event: any) => (_ctx.focusProposedArea(area))
                              }, [
                                _createElementVNode("span", {
                                  class: "town-zoning-plan-map__swatch",
                                  style: _normalizeStyle({background: _ctx.proposedAreaColor(area)})
                                }, null, 4),
                                _createElementVNode("span", _hoisted_41, [
                                  (area.code)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_42, _toDisplayString(area.code), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.proposedAreaName(area)), 1)
                                ]),
                                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.formatHectares(area.hectares)) + " ha", 1)
                              ], 10, _hoisted_40))
                            }), 128))
                          ]),
                          (_ctx.filteredProposedAreas.length > _ctx.shownProposedAreas.length)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-link btn-sm p-0 mt-1 text-decoration-none",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.shownProposedAreaCount += _ctx.PROPOSED_AREAS_PAGE_SIZE))
                              }, " Zobrazit dalších " + _toDisplayString(Math.min(_ctx.PROPOSED_AREAS_PAGE_SIZE, _ctx.filteredProposedAreas.length - _ctx.shownProposedAreas.length)), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}